import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_1942344232, { _demoInfo as Basic_1942344232_demoInfo } from "../../../../../packages/console-rose-chart/demo/Basic.tsx?loadDemo";
import Axis_1942344232, { _demoInfo as Axis_1942344232_demoInfo } from "../../../../../packages/console-rose-chart/demo/Axis.tsx?loadDemo";
import SingleColor_1942344232, { _demoInfo as SingleColor_1942344232_demoInfo } from "../../../../../packages/console-rose-chart/demo/SingleColor.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_1942344232,
  Basic_1942344232_demoInfo,
  Axis_1942344232,
  Axis_1942344232_demoInfo,
  SingleColor_1942344232,
  SingleColor_1942344232_demoInfo,
  React
};